var _g, _defs;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogoHome = function SvgLogoHome(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5249 28.1775C12.3983 28.3788 12.3279 28.6104 12.3211 28.8481C12.3143 29.0858 12.3712 29.3209 12.4861 29.5292C12.6009 29.7374 12.7694 29.9111 12.9741 30.0321C13.1788 30.1532 13.4121 30.2172 13.6499 30.2176H28.8487C28.9627 30.217 29.0747 30.2471 29.1732 30.3046C29.2716 30.3621 29.3528 30.445 29.4084 30.5445C29.4639 30.6441 29.4917 30.7567 29.4889 30.8707C29.4861 30.9847 29.4528 31.0958 29.3924 31.1925L14.4749 55.0763C14.4378 55.1378 14.3886 55.1911 14.3304 55.2331C14.2721 55.2751 14.206 55.3049 14.1359 55.3206C14.0658 55.3364 13.9933 55.3378 13.9227 55.3248C13.852 55.3119 13.7848 55.2847 13.7249 55.245C8.35038 51.7731 4.22514 46.6754 1.95039 40.695C-0.324365 34.7145 -0.629726 28.1639 1.07881 21.9978C2.78734 15.8317 6.42046 10.3723 11.4487 6.41544C16.4769 2.45854 22.6374 0.210885 29.0324 5.25617e-05C29.1271 -0.0012832 29.2205 0.0228626 29.3027 0.0699645C29.3849 0.117066 29.453 0.185394 29.4997 0.2678C29.5465 0.350206 29.5703 0.443663 29.5685 0.538396C29.5668 0.633129 29.5396 0.725657 29.4899 0.806303L12.5249 28.1775ZM46.7999 5.1338C46.7408 5.09275 46.674 5.06426 46.6034 5.05013C46.5329 5.03599 46.4602 5.0365 46.3899 5.05162C46.3196 5.06674 46.2531 5.09615 46.1946 5.13802C46.1361 5.1799 46.0869 5.23335 46.0499 5.29505L31.3612 28.8263C31.301 28.9228 31.2677 29.0335 31.2647 29.1472C31.2617 29.2608 31.2892 29.3732 31.3443 29.4727C31.3994 29.5721 31.4801 29.655 31.578 29.7128C31.6759 29.7706 31.7875 29.8012 31.9012 29.8013H47.0999C47.3377 29.8016 47.5711 29.8657 47.7757 29.9867C47.9804 30.1078 48.1489 30.2815 48.2638 30.4897C48.3786 30.6979 48.4355 30.9331 48.4287 31.1708C48.4219 31.4085 48.3515 31.64 48.2249 31.8413L31.0424 59.3588C31.0021 59.4237 30.9802 59.4984 30.9792 59.5748C30.9782 59.6512 30.998 59.7265 31.0366 59.7925C31.0752 59.8584 31.131 59.9126 31.1981 59.9492C31.2652 59.9858 31.3411 60.0034 31.4174 60C37.7133 59.6949 43.7535 57.4164 48.6824 53.4873C53.6113 49.5582 57.1788 44.1778 58.8796 38.1083C60.5805 32.0389 60.3283 25.5881 58.1589 19.6699C55.9896 13.7517 52.0129 8.66617 46.7924 5.1338H46.7999Z",
    fill: "url(#paint0_linear_5_646)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_646",
    x1: 25.8974,
    y1: 12.3826,
    x2: 36.4462,
    y2: 57.7051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#00FFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#00F8D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00E4D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00C3D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#0096D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#005CD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#0016D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#0000D5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_646"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoHome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-home.a70429a7.svg";
export { ForwardRef as ReactComponent };